// vms-saved-tv.js: the shopper's saved TV (localStorage), its writers, the header item, the account sync and the lookup log. Notes: assets/vms-saved-tv.notes.md
(function () {
  'use strict';
  if (window.VMSSavedTv) return;
  var KEY = 'vms:tv', LIST = 'vms:tvs', CAP = 10, DROP = ['explicit', 'prefill', 'query'];
  var MARK = 'vms:tv-acct', SID = 'vms:sid', DONE = 'vms:tv-sync', OFF = 'vms:tv-local', PICKS = 'vms:tv-picks', SENT = 'vms:tv-picks-sent', TIED = 'vms:tv-sid-sent';
  var TVS = '/apps/toolkit/tvs', CHOICE = '/apps/toolkit/tv-choice', mem = {}, last = '', gen = 0;

  function read(k) { try { var s = window.localStorage.getItem(k); return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  function write(k, v) { try { if (v == null) window.localStorage.removeItem(k); else window.localStorage.setItem(k, JSON.stringify(v)); return true; } catch (e) { return false; } }
  function sget(k) { try { var v = window.sessionStorage.getItem(k); if (v != null) return v; } catch (e) {} return Object.prototype.hasOwnProperty.call(mem, k) ? mem[k] : null; }
  function sset(k, v) { mem[k] = v; try { if (v == null) window.sessionStorage.removeItem(k); else window.sessionStorage.setItem(k, v); } catch (e) {} }
  function has(v) { return v !== null && v !== undefined && v !== ''; }
  function pos(v) { var n = typeof v === 'number' ? v : (typeof v === 'string' && /^\d+(\.\d+)?$/.test(v.trim()) ? Number(v) : NaN); return isFinite(n) && n > 0 ? n : null; }
  function int(v) { var n = pos(v); return n == null ? null : Math.round(n); }
  function time(t) { var n = Date.parse(t); return isFinite(n) ? n : 0; }
  function alnum(t) { return String(t == null ? '' : t).toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function nice(x) { var v = Math.round(x * 10) / 10; return v % 1 === 0 ? String(Math.round(v)) : v.toFixed(1); }

  function valid(r) {
    if (!r || typeof r !== 'object' || !r.row || typeof r.row !== 'object') return false;
    if (r.source === 'catalog') return has(r.row.model_number);
    return r.source === 'hand' && (pos(r.row.screen_size_in) != null || (pos(r.row.vesa_width_mm) != null && pos(r.row.vesa_height_mm) != null));
  }
  function sizeOf(r) { var s = r.opt && pos(r.opt.size); if (s == null) s = pos(r.row.screen_size_in); return s == null ? null : Math.round(s); }
  function label(r) {
    var row = r.row, s = sizeOf(r), w = pos(row.vesa_width_mm), h = pos(row.vesa_height_mm);
    if (r.source === 'catalog') return ((has(row.manufacturer) ? row.manufacturer + ' ' : '') + String(row.model_number)).trim();
    var p = [];
    if (s != null) p.push(s + ' in');
    if (w != null && h != null) p.push('VESA ' + nice(w) + ' x ' + nice(h));
    return p.join(', ');
  }
  function keyOf(r) {
    if (r.source === 'catalog') return 'c:' + alnum(r.row.model_number);
    var s = sizeOf(r), w = int(r.row.vesa_width_mm), h = int(r.row.vesa_height_mm);
    return 'h:' + (s == null ? '' : s) + ':' + (w != null && h != null ? w + 'x' + h : '');
  }

  function flag(on) { var d = document.documentElement; if (on) d.setAttribute('data-vms-tv', ''); else d.removeAttribute('data-vms-tv'); }
  function emit(rec, cause) {
    try { document.dispatchEvent(new CustomEvent('vms:tv-changed', { detail: { tv: rec, cause: cause, hidden: !!document.hidden } })); } catch (e) {}
  }

  function get() { var r = read(KEY); return valid(r) ? r : null; }
  function list() { var l = read(LIST); return Array.isArray(l) ? l.filter(valid) : []; }

  function make(row, opts) {
    opts = opts || {};
    var copy = {};
    for (var k in row) if (Object.prototype.hasOwnProperty.call(row || {}, k) && DROP.indexOf(k) === -1) copy[k] = row[k];
    var size = pos(opts.size);
    var rec = { row: copy, opt: { size: size == null ? null : Math.round(size) }, source: opts.source === 'hand' ? 'hand' : 'catalog', display_name: '', catalog_version: has(opts.catalog_version) ? String(opts.catalog_version) : (has(copy.catalog_version) ? String(copy.catalog_version) : null), saved_at: new Date().toISOString() };
    if (!valid(rec)) return null;
    rec.display_name = label(rec);
    return rec;
  }
  function put(rec, cause) {
    if (!write(KEY, rec)) return false;
    var id = keyOf(rec);
    write(LIST, [rec].concat(list().filter(function (x) { return keyOf(x) !== id; })).slice(0, CAP));
    flag(true);
    emit(rec, cause);
    return true;
  }
  function set(row, opts) { var rec = make(row, opts); if (!rec || !put(rec, 'set')) return null; gen++; push(rec); return rec; }
  function clear() {
    var r = get();
    gen++;
    write(KEY, null); flag(false); emit(null, 'clear');
    if (r && live()) call(TVS + '/remove', { v: 1, key: keyOf(r) });
  }

  function toTv(rec, F) {
    F = F || window.VMSMountFit;
    if (!rec || !F) return null;
    if (rec.source === 'catalog') return F.tvFromRow(rec.row, { size: rec.opt && rec.opt.size, catalogVersion: rec.catalog_version });
    var w = pos(rec.row.vesa_width_mm), h = pos(rec.row.vesa_height_mm);
    return F.tvFromParams({ size: sizeOf(rec), vesa: w != null && h != null ? w + 'x' + h : null });
  }

  function findUrl(rec, base) {
    var u = base || '/pages/find-mounts-by-tv-model', p = [];
    if (rec && rec.source === 'catalog') p.push('tvm=' + encodeURIComponent(rec.row.model_number));
    var s = rec ? sizeOf(rec) : null;
    if (s != null) p.push('size=' + s);
    if (rec && rec.source === 'hand' && pos(rec.row.vesa_width_mm) != null && pos(rec.row.vesa_height_mm) != null) p.push('vesa=' + nice(pos(rec.row.vesa_width_mm)) + 'x' + nice(pos(rec.row.vesa_height_mm)));
    return p.length ? u + '?' + p.join('&') : u;
  }

  function signedIn() { var h = document.querySelector && document.querySelector('[data-vms-tv-sync]'); return !!h && h.getAttribute('data-vms-tv-sync') === '1'; }
  function live() { return signedIn() && sget(OFF) !== '1' && typeof window.fetch === 'function'; }
  function call(url, payload, done) {
    var fin = function (t) { if (done) { try { done(t); } catch (e) {} } };
    var ctrl = window.AbortController ? new window.AbortController() : null, kill = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    var init = { credentials: 'same-origin', headers: { Accept: 'application/json' }, signal: ctrl ? ctrl.signal : undefined };
    if (payload) { init.method = 'POST'; init.headers['Content-Type'] = 'application/json'; init.body = JSON.stringify(payload); }
    try {
      window.fetch(url, init).then(function (res) {
        if (res.status === 401) { sset(OFF, '1'); return null; }
        if (res.status !== 200) return null;
        return res.json().then(function (b) { return b && b.ok === true && Array.isArray(b.tvs) ? b.tvs : null; });
      }).then(function (t) { clearTimeout(kill); fin(t); }, function () { clearTimeout(kill); fin(null); });
    } catch (e) { clearTimeout(kill); fin(null); }
  }
  function bytes(s) { try { return unescape(encodeURIComponent(s)).length; } catch (e) { return Infinity; } }
  function upto(v, n) { return has(v) && String(v).length <= n; }
  function postable(r) {
    var s = sizeOf(r), id = r.row.tv_id, w = int(r.row.vesa_width_mm), h = int(r.row.vesa_height_mm);
    if ((s != null && s > 150) || !upto(label(r), 120)) return false;
    if (r.source === 'hand') return s != null && (w == null || h == null || (w <= 2000 && h <= 2000));
    return /^\d+$/.test(String(id)) && Number(id) > 0 && Number(id) <= 2147483647 && upto(r.row.model_number, 64) && upto(r.catalog_version, 64) && bytes(JSON.stringify(r.row)) <= 4096;
  }
  function mark(r) { var c = {}; for (var k in r) if (Object.prototype.hasOwnProperty.call(r, k)) c[k] = r[k]; c.from = 'account'; return c; }
  function body(r) {
    var row = r.row, w = int(row.vesa_width_mm), h = int(row.vesa_height_mm), hand = { screen_size_in: sizeOf(r) };
    if (w != null && h != null) { hand.vesa_width_mm = w; hand.vesa_height_mm = h; }
    if (r.source === 'hand') return { source: 'hand', tv_id: null, model_number: null, catalog_version: null, display_name: label(r).slice(0, 120), size_in: sizeOf(r), row: hand, saved_at: r.saved_at };
    return { source: 'catalog', tv_id: row.tv_id, model_number: String(row.model_number), catalog_version: r.catalog_version, display_name: label(r).slice(0, 120), size_in: sizeOf(r), row: row, saved_at: r.saved_at };
  }
  function push(rec) { if (live() && postable(rec)) call(TVS, { v: 1, tv: body(rec), make_current: true }, function (t) { if (t) mergeList(t); }); }
  function fromServer(e) {
    if (!e || typeof e !== 'object' || !e.row || typeof e.row !== 'object') return null;
    var rs = pos(e.row.screen_size_in), sz = pos(e.size_in), cat = e.source !== 'hand';
    var r = { row: e.row, opt: { size: cat && sz != null && (rs == null || Math.round(rs) !== Math.round(sz)) ? Math.round(sz) : null }, source: cat ? 'catalog' : 'hand', display_name: '', catalog_version: has(e.catalog_version) ? String(e.catalog_version) : null, saved_at: String(e.saved_at || ''), from: 'account' };
    if (!valid(r)) return null;
    r.display_name = label(r);
    return r;
  }
  function srv(tvs) { var out = []; (Array.isArray(tvs) ? tvs : []).forEach(function (e) { var r = fromServer(e); if (r) out.push({ rec: r, current: e.current === true }); }); return out; }
  function mergeList(tvs, keep) {
    var s = srv(tvs), on = {}, pick = {}, cur = get(), ck, out = [];
    s.forEach(function (x) { on[keyOf(x.rec)] = 1; });
    if (cur && on[keyOf(cur)] && cur.from !== 'account') { cur = mark(cur); write(KEY, cur); }
    ck = cur ? keyOf(cur) : null;
    list().concat(keep ? [keep] : [], s.map(function (x) { return x.rec; })).forEach(function (r) {
      var k = keyOf(r);
      if (r.from === 'account' && !on[k]) return;
      if (on[k] && r.from !== 'account') r = mark(r);
      if (!pick[k] || time(r.saved_at) > time(pick[k].saved_at)) pick[k] = r;
    });
    if (cur) pick[ck] = cur;
    for (var k in pick) if (Object.prototype.hasOwnProperty.call(pick, k)) out.push(pick[k]);
    out.sort(function (a, b) { return (keyOf(b) === ck) - (keyOf(a) === ck) || time(b.saved_at) - time(a.saved_at); });
    write(LIST, out.slice(0, CAP));
  }
  function reconcile(tvs, again, g) {
    if (g !== gen) return;
    var cur = get(), sc = null, mine = null;
    srv(tvs).forEach(function (x) { if (x.current) sc = x.rec; if (cur && keyOf(x.rec) === keyOf(cur)) mine = x.rec; });
    if (cur && cur.from === 'account' && !mine) { write(KEY, null); flag(false); emit(null, 'account'); cur = null; }
    if (again && cur && postable(cur) && (!mine || time(cur.saved_at) > time(mine.saved_at))) {
      call(TVS, { v: 1, tv: body(cur), make_current: !sc || time(cur.saved_at) > time(sc.saved_at) }, function (t) { reconcile(t || tvs, false, g); });
      return;
    }
    if (sc && (!cur || time(sc.saved_at) > time(cur.saved_at))) put(sc, 'account');
    mergeList(tvs, cur);
  }
  function signout() {
    if (signedIn() || !(document.querySelector && document.querySelector('.vms-header'))) return;
    sset(DONE, null); sset(OFF, null);
    if (!read(MARK)) return;
    write(MARK, null);
    write(LIST, list().filter(function (r) { return r.from !== 'account'; }));
    var c = get();
    if (c && c.from === 'account') { write(KEY, null); flag(false); emit(null, 'signout'); }
  }
  function sync() {
    if (!signedIn()) return;
    write(MARK, 1);
    if (sget(DONE) === '1' || !live()) return;
    sset(DONE, '1');
    var g = gen;
    call(TVS, null, function (t) { if (t) reconcile(t, true, g); });
  }

  function hex() {
    var b = new Uint8Array(8), s = '', i;
    try { window.crypto.getRandomValues(b); } catch (e) { for (i = 0; i < 8; i++) b[i] = Math.floor(Math.random() * 256); }
    for (i = 0; i < 8; i++) s += (b[i] < 16 ? '0' : '') + b[i].toString(16);
    return s;
  }
  function sid() { var s = sget(SID); if (!/^[0-9a-f]{16}$/.test(s || '')) { s = hex(); sset(SID, s); } return s; }
  function beacon(b) {
    var s = JSON.stringify(b), n = window.navigator;
    try {
      if (typeof window.fetch === 'function') window.fetch(CHOICE, { method: 'POST', keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: s }).catch(function () {});
      else if (n && n.sendBeacon) n.sendBeacon(CHOICE, new Blob([s], { type: 'application/json' }));
    } catch (e) {}
  }
  function picks(name) {
    var l = null;
    try { l = JSON.parse(sget(PICKS) || '[]'); } catch (e) {}
    name = String(name).replace(/\|/g, '/').trim();
    l = [name].concat((Array.isArray(l) ? l : []).filter(function (x) { return typeof x === 'string' && x !== name; })).slice(0, 5);
    while (l.length > 1 && l.join('|').length > 250) l.pop();
    sset(PICKS, JSON.stringify(l));
    return l.join('|').slice(0, 250);
  }
  function attrs(name) {
    var v = picks(name), id = sid(), mark = id + ' ' + v;
    if (sget(SENT) === mark || typeof window.fetch !== 'function') return;
    try {
      window.fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _vms_sid: id, _vms_tv_lookups: v } }) })
        .then(function (r) { if (r && r.ok) sset(SENT, mark); }, function () {});
    } catch (e) {}
  }
  function tie() {
    var id = sid();
    if (sget(TIED) === id || (sget(SENT) || '').indexOf(id + ' ') === 0 || typeof window.fetch !== 'function') return;
    sset(TIED, id);
    try {
      window.fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', { method: 'POST', keepalive: true, credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { _vms_sid: id } }) })
        .then(function (r) { if (!r || !r.ok) sset(TIED, null); }, function () { sset(TIED, null); });
    } catch (e) { sset(TIED, null); }
  }
  function send(rec, host, via) {
    var hand = rec.source === 'hand', row = rec.row, size = rec.opt && rec.opt.size != null ? rec.opt.size : pos(row.screen_size_in), name = label(rec), k = keyOf(rec) + '|' + size;
    if (k === last) return;
    last = k;
    var b = { sid: sid(), tv_id: hand || !has(row.tv_id) ? null : row.tv_id, model_number: (hand ? name : String(row.model_number)).slice(0, 64), manufacturer: hand || !has(row.manufacturer) ? null : String(row.manufacturer).slice(0, 64), screen_size_in: size, lookup_status: hand ? 'hand' : (has(row.lookup_status) ? String(row.lookup_status).slice(0, 64) : null), catalog_version: hand || !has(rec.catalog_version) ? null : String(rec.catalog_version).slice(0, 64), host: host || 'unknown', path: String(window.location && window.location.pathname || '/').slice(0, 200), ts: new Date().toISOString() };
    if (via) b.via = via;
    beacon(b);
  }
  function choice(rec, host) { send(rec, host); attrs(label(rec)); }
  function sendChoice(row, host) { var rec = row && row.lookup_status !== 'not_real_model' ? make(row, { source: 'catalog', catalog_version: row.catalog_version }) : null; if (rec) { send(rec, host, 'typed'); tie(); } }
  function chosen(rec, host) { if (!rec) return; gen++; if (put(rec, 'set')) push(rec); choice(rec, host); }

  document.addEventListener('vms:tv-selected', function (e) {
    var d = e.detail || {};
    if (d.explicit !== true || d.prefill === true || d.lookup_status === 'not_real_model') return;
    chosen(make(d, { source: 'catalog', catalog_version: d.catalog_version }), e.target && e.target.getAttribute ? e.target.getAttribute('data-host') : '');
  });
  document.addEventListener('vms:tv-chosen', function (e) {
    var d = e.detail || {}, host = d.host || 'finder';
    if (d.source === 'catalog' && d.row) { if (d.row.lookup_status !== 'not_real_model') chosen(make(d.row, { source: 'catalog', size: d.size, catalog_version: d.row.catalog_version }), host); return; }
    if (d.source === 'hand') chosen(make({ screen_size_in: pos(d.size), vesa_width_mm: pos(d.vesa_width_mm), vesa_height_mm: pos(d.vesa_height_mm) }, { source: 'hand' }), host);
  });
  window.addEventListener('storage', function (e) {
    if (e.key !== KEY && e.key !== null) return;
    var r = get();
    flag(!!r);
    emit(r, 'storage');
  });

  function close(item, focus) {
    var btn = item.querySelector('[data-vms-tv-btn]'), pop = item.querySelector('[data-vms-tv-pop]');
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    if (btn) btn.setAttribute('aria-expanded', 'false');
    if (focus && btn) btn.focus();
  }
  function paint(item) {
    var r = get(), name = r ? label(r) : '';
    item.querySelectorAll('[data-vms-tv-name]').forEach(function (n) { n.textContent = name; });
    var btn = item.querySelector('[data-vms-tv-btn]'), ch = item.querySelector('[data-vms-tv-change]');
    if (btn) { btn.setAttribute('aria-label', r ? 'Your TV: ' + name : 'Your TV'); btn.title = r ? 'Your TV: ' + name : ''; }
    if (ch) ch.href = findUrl(r, item.getAttribute('data-find-url'));
    if (!r) close(item);
  }
  function bind(item) {
    if (item.vmsTv) return;
    item.vmsTv = true;
    var btn = item.querySelector('[data-vms-tv-btn]'), pop = item.querySelector('[data-vms-tv-pop]'), clr = item.querySelector('[data-vms-tv-clear]');
    if (btn && pop) btn.addEventListener('click', function () {
      if (!pop.hidden) { close(item); return; }
      pop.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
    });
    if (clr) clr.addEventListener('click', function () {
      clear();
      var f = item.querySelector('[data-vms-tv-find]');
      if (f) f.focus();
    });
    item.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop && !pop.hidden) { e.preventDefault(); close(item, true); } });
    item.addEventListener('focusout', function (e) { if (e.relatedTarget && !item.contains(e.relatedTarget)) close(item); });
    document.addEventListener('click', function (e) { if (!item.contains(e.target)) close(item); });
    paint(item);
  }
  function items() { return document.querySelectorAll('[data-vms-tv-item]'); }
  function init() { if (signedIn()) write(MARK, 1); else signout(); flag(!!get()); items().forEach(bind); var on = signedIn(); document.querySelectorAll('[data-vms-tv-acct]').forEach(function (n) { n.hidden = !on; }); }
  function later() { if (document.readyState === 'complete') setTimeout(sync, 0); else window.addEventListener('load', sync); }

  document.addEventListener('vms:tv-changed', function () { items().forEach(paint); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  later();

  window.VMSSavedTv = { get: get, set: set, clear: clear, list: list, toTv: toTv, findUrl: findUrl, label: label, key: keyOf, sid: sid, sendChoice: sendChoice, KEY: KEY, LIST: LIST, CAP: CAP };
})();
